import GrupoUsuarios from "model/administracao/cadastro/GrupoUsuarios";
import DocumentoAcao from "./DocumentoAcao";

export default class DocumentoAcessoGrupo {
    grupo: GrupoUsuarios; 
    acoes: DocumentoAcao[];

    constructor(grupo: GrupoUsuarios, acoes: DocumentoAcao[]) {
        this.grupo = grupo;
        this.acoes = acoes;
    }
}